import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { setSegmentSelected } from "../../../store/templateDetail";
import { findTemplate } from "../../../store/templateDetail/actions/findTemplate";
import { findTemplateQuestions } from "../../../store/templateDetail/actions/findTemplateQuestions";


export const ParamsWatcher = () => {
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();

  useEffect(() => {
    dispatch(findTemplate(id));
    dispatch(findTemplateQuestions(id));
    dispatch(setSegmentSelected("preview"));
  }, [dispatch, id]);

  return <></>;
};
